var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiButton from "@material-ui/core/Button";
import capitalize from "@material-ui/core/utils/capitalize";
import { Spinner } from "../spinner";
import { fade, makeStyles } from "../styles";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
export var ButtonComponentName = "CosmosButton";
export var useButtonStyles = makeStyles(function (theme) { return ({
    root: {},
    label: {},
    labelLoading: {
        color: "transparent",
    },
    loadingIndicator: {
        position: "absolute",
    },
    text: {},
    outlined: {},
    containedError: {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.mixins.shadeOfColor("red", "base"),
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.mixins.shadeOfColor("red", "dark"),
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.mixins.shadeOfColor("red", "darker"),
        },
    },
    outlinedError: {
        color: theme.palette.error.main,
        border: "1px solid " + fade(theme.palette.error.main, 0.5),
        "&:hover": {
            border: "1px solid " + theme.palette.error.main,
            backgroundColor: fade(theme.palette.error.main, theme.palette.action.hoverOpacity),
        },
    },
    textError: {
        color: theme.palette.error.main,
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.mixins.shadeOfColor("red", "lightest"),
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.mixins.shadeOfColor("red", "lighter"),
        },
    },
}); }, { name: ButtonComponentName });
export var getButtonAppearanceProps = function (appearance) {
    switch (appearance) {
        case "cta":
            return {
                color: "secondary",
                variant: "contained",
            };
        case "primary":
            return {
                color: "primary",
                variant: "contained",
            };
        case "secondary": {
            return {
                color: "default",
                variant: "outlined",
            };
        }
        case "default": {
            return {
                color: "default",
                variant: "contained",
            };
        }
        case "destructive": {
            return {
                color: "error",
                variant: "contained",
            };
        }
        case "link": {
            return {
                color: "primary",
                variant: "text",
            };
        }
        default: {
            return {};
        }
    }
};
/** @deprecated this variant was originally used in Cosmos and is no longer usable */
var deprecatedSecondaryVariant = "secondary";
export var Button = React.forwardRef(function (props, ref) {
    var classes = useButtonStyles(props);
    var isLoading = props.isLoading, className = props.className, disabled = props.disabled, children = props.children, label = props.label, _a = props.classes, buttonClassess = _a === void 0 ? {} : _a, colorProp = props.color, _b = props.variant, variantProp = _b === void 0 ? "text" : _b, appearance = props.appearance, buttonProps = __rest(props, ["isLoading", "className", "disabled", "children", "label", "classes", "color", "variant", "appearance"]);
    var _c = !!appearance
        ? getButtonAppearanceProps(appearance)
        : {
            color: colorProp,
            variant: variantProp,
        }, possibleColor = _c.color, variant = _c.variant;
    var color = possibleColor === "danger" ? "error" : possibleColor;
    return (React.createElement(MuiButton, __assign({}, getCosmosDataProps("button"), { className: clsx(classes.root, color && classes["color" + capitalize(color)], variant && classes[variant], color === "error" && classes["" + variant + capitalize(color)], className), classes: __assign(__assign({}, buttonClassess), { label: clsx(isLoading && classes.labelLoading, buttonClassess.label) }) }, buttonProps, { disabled: isLoading || disabled, variant: variant === "link" ? "text" : variant, color: color === "error" ? undefined : color, ref: ref }),
        label || children,
        " ",
        !!isLoading && React.createElement(Spinner, { className: classes.loadingIndicator })));
});
